<template lang="pug">
  .dropdown-with-toggles.input.input--select
    .dropdown-with-toggles__label(
      @click="toggleDropdown"
    )
      .dropdown-with-toggles__label-inner(
        v-text="labelText"
      )
      .dropdown-with-toggles__label-icon(
        :class="{open: toggleOpen}"
      )
        icon(
          name="chevron-down"
          size="22px"
        ) 
    .dropdown-with-toggles__inner(
      v-if="toggleOpen"
    )
      checkbox-toggle-all(
        label="All Stores"
        :checked="toggleAllState"
        :allOptions="dropdownOptions"
        @input="toggleAllValues"
      )
      checkbox-input(
        v-for="(value, key) in dropdownOptions"
        :key="key"
        :label="key"
        :value="key"
        :checked="value"
        @input="updateCheckboxValue(key)"
      )
    .dropdown-with-toggles__toggle
</template>

<script>
  import CheckboxInput from 'scripts/components/forms/CheckboxInput.vue'
  import CheckboxToggleAll from 'scripts/components/forms/CheckboxToggleAll.vue'
  import Icon from 'scripts/components/basic/Icon.vue'

  export default {
    name: 'DropdownWithToggles',
    components: {
      CheckboxInput,
      CheckboxToggleAll,
      Icon,
    },
    props: {
      options: Object,
      enableToggleAll: {
        type: Boolean,
        default: false
      },
      label: String,
    },
    computed: {
      toggleAllState() {
        if (Object.values(this.dropdownOptions).every(Boolean)) {
          return 'checked'
        } else if (Object.values(this.dropdownOptions).every(option => option === false)) {
          return 'unchecked'
        } else {
          return 'intermediary'
        }
      },
      labelText() {
        const optionKeys = Object.keys(this.dropdownOptions);
        const values = Object.values(this.dropdownOptions);
        const selectedKeys = optionKeys.filter((key) => this.dropdownOptions[key] === true);
        const firstSelected = selectedKeys[0];

        if (values.every(option => option === false)) {
          return this.label
        } else if (selectedKeys.length === 1) {
          return firstSelected 
        }

        return `${firstSelected} +${selectedKeys.length - 1}` 
      }
    },
    methods: {
      toggleDropdown() {
        this.toggleOpen = !this.toggleOpen;
      },
      toggleAllValues(value) {
        const valToBool= value === 'checked' ? true : false;
        Object.keys(this.dropdownOptions).forEach((key) => this.dropdownOptions[key] = valToBool);
      },
      updateCheckboxValue(option) {
        this.dropdownOptions[option] = !this.dropdownOptions[option];
      }
    },
    data() {
      return {
        toggleOpen: false,
        dropdownOptions: this.options
      }
    },
    watch: {
      options() {
        this.dropdownOptions = this.options
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dropdown-with-toggles {
    padding: 0 10px;
    position: relative;
  }

  .dropdown-with-toggles__label {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 36px;
    justify-content: space-between;
  }

  .dropdown-with-toggles__label-icon {
    transition: .1s linear all;
    -moz-transition: .1s linear all;
    -webkit-transition: .1s linear all;

    &.open {
      transform: rotate(180deg);
    }
  }

  .dropdown-with-toggles__inner {
    background-color: var(--color-white);
    border: 1px solid var(--color-grey-500);
    display: flex;
    flex-direction: column;
    max-height: 280px;
    max-width: 190px;
    overflow: auto;
    position: absolute;
    top: 36px;
    left: -1px;
    right: -1px;
    z-index: 10;
  }

  .dropdown-with-toggles__inner .checkbox-input {
    margin: 9px 15px;

    &:first-child {
      margin-top: 17px;
    }
  }
</style>